import React from "react";

interface Props {
  title: string;
  id: string;
  isCollapsed?: boolean;
}

class PlusCollapsible extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, id, isCollapsed, children } = this.props;
    const itemId = id.replace(/\/| /g, "");
    return (
      <div className="generic-plus-accordion container">
        <div className="panel panel-default">
          <div className="panel-heading" role="tab">
            <h4 className="panel-title">
              <a
                data-toggle="collapse"
                href={"#" + itemId}
                aria-expanded={isCollapsed ? "false" : "true"}
                aria-controls={itemId}
                className={isCollapsed ? "collapsed" : ""}
              >
                {title}
              </a>
            </h4>
          </div>
          <div id={itemId} className={isCollapsed ? "collapse" : "collapse in"}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default PlusCollapsible;
